import { Box, Grid, Theme, Typography } from "@mui/material";
import { SystemStyleObject } from "@mui/system";

export interface Props {
  title?: string;
  actionButton?: React.ReactNode;
  children?: React.ReactNode;
  sx?: SystemStyleObject<Theme>;
}

export const AccountPageLayout = ({
  title,
  actionButton,
  children,
  sx,
}: Props) => {
  return (
    <Grid sx={[{ py: 4, px: 4, height: "100%" }, ...(sx ? [sx] : [])]}>
      <Grid size={{ xs: 1 }} />
      <Grid
        size={{ xs: 10 }}
        sx={{ height: "100%", display: "flex", flexDirection: "column" }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            rowGap: 2,
            columnGap: 2,
            mb: 1,
          }}
        >
          {title == null ? null : <Typography variant="h1">{title}</Typography>}
          {actionButton ?? null}
        </Box>
        {children}
      </Grid>
      <Grid size={{ xs: 1 }} />
    </Grid>
  );
};
